import { Ticket, Armchair, Bus, Wifi, Luggage, Usb, Snowflake, Coffee, MousePointerClick } from "lucide-react";
import { FadeUp, MaskLines, Eyebrow } from "../site/Motion";
import { INCLUDES } from "../../lib/site";

const FEATS = [
  { Icon: Ticket, t: "Comprá online", d: "Rápido, seguro y desde donde estés." },
  { Icon: Armchair, t: "Elegí tu asiento", d: "Semicama 130°, coche cama 160° o suite." },
  { Icon: Bus, t: "Viajá cómodo", d: "Unidades doble piso, modernas y confiables." },
];
const INC_ICONS = [Wifi, Luggage, Usb, MousePointerClick, Snowflake, Coffee];

export const Features = () => (
  <section data-testid="home-features" className="bg-white py-20 md:py-32">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Eyebrow>Por qué Santiagueño</Eyebrow>
          <h2 className="mt-5 font-display text-4xl md:text-6xl"><MaskLines inView lines={["Rutas del norte,", "con sello propio."]} /></h2>
        </div>
        <div className="divide-y divide-black/10 border-y border-black/10 lg:col-span-7">
          {FEATS.map(({ Icon, t, d }, i) => (
            <FadeUp key={t} delay={i * 0.08} className="group flex items-center gap-6 py-7">
              <span className="font-mono text-sm text-[var(--muted-ink)]">0{i + 1}</span>
              <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-[var(--paper)] text-[var(--forest)] transition-[background-color,color,transform] duration-500 group-hover:-rotate-6 group-hover:bg-[var(--forest)] group-hover:text-[var(--lime)]">
                <Icon className="h-6 w-6" />
              </span>
              <div>
                <p className="font-display-up text-xl md:text-2xl">{t}</p>
                <p className="mt-1 text-[var(--muted-ink)]">{d}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
      <FadeUp className="mt-16">
        <p className="mb-5 font-mono text-xs uppercase tracking-[0.25em] text-[var(--muted-ink)]">A bordo de cada servicio</p>
        <div className="flex flex-wrap gap-3">
          {INCLUDES.map((x, i) => {
            const I = INC_ICONS[i];
            return (
              <span key={x} data-testid={`include-chip-${i}`} className="inline-flex items-center gap-2 rounded-full border border-black/10 px-5 py-3 text-sm font-semibold transition-colors duration-300 hover:border-[var(--forest)] hover:bg-[var(--forest)] hover:text-white">
                <I className="h-4 w-4" /> {x}
              </span>
            );
          })}
        </div>
      </FadeUp>
    </div>
  </section>
);
